module.exports = __webpack_public_path__ + "img/jump-link.38299350.svg";